export default __webpack_public_path__ + "static/media/8.7b8bbb34.jpg";